import {
    Component,
    HostListener,
    Inject,
    Input,
    OnInit,
    ViewChild,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TextUtils } from "../../../../util/TextUtils";
import { CookieService } from "ngx-cookie-service";
import { StorageService } from "app/main/module/common/service/storage.service";
import * as moment from "moment";
import {
    APP_DATE_FORMATS,
    AppDateAdapter,
} from "../../report/format-datepicker";
import {
    DateAdapter,
    ErrorStateMatcher,
    MAT_DATE_FORMATS,
} from "@angular/material/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Globals } from "../../../common/global";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { fromEvent, of, Subscription } from "rxjs";
import {
    catchError,
    debounceTime,
    distinctUntilChanged,
    switchMap,
} from "rxjs/operators";
import { AssignService } from "../../cassette/assign/assign.service";
import { TimestampService } from "app/main/module/common/timeConstant.service";
import { SEVERITY_TYPES, statusType, Tickets } from "../tickets";
import { SignaturePad } from "angular2-signaturepad";
import { TicketsService } from "../tickets.service";
import { TableRefreshService } from "../table-refresh.service";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Component({
    selector: "app-add-tickets",
    templateUrl: "./add-tickets.component.html",
    styleUrls: ["./add-tickets.component.scss"],
    providers: [
        { provide: DateAdapter, useClass: AppDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    ],
})
export class AddTicketsComponent implements OnInit {
    [x: string]: any;
    ticketForm: FormGroup;
    platform = "web";
    @Input()
    min: "D" | null;
    today = new Date();
    isEnterPressed = false;
    hasFirstDataShown: Boolean;
    dobStamp = 0;
    dobString = "";
    deleted: boolean;
    rowId: any;
    memberInfo: any;
    errorMessage: any;
    @ViewChild("input", { static: true }) input: any;
    @ViewChild("filter", { static: true }) filter: any;
    searchInputSubscription: Subscription;
    message: any;
    inputValue: string;
    filteredPatients: Array<any> = [];
    HASH = "#";
    showNoResultsMessage = false;
    isLoading = false;
    patientlist: Array<any> = [];
    name: string;
    selectLab: string;
    labTimeZone: string;
    minDate: Date;
    uniqueTimestamp: any;
    startAt: any;
    equipmentTypes = [];
    severityTypes = SEVERITY_TYPES;
    technicianList = [];
    statusList = statusType;
    @ViewChild(SignaturePad) signaturePad: SignaturePad;
    userId: string;
    entitledFor = [
        { id: "support", name: "Support" },
        { id: "technician", name: "Technician" },
    ];
    assignedToList: any;
    supportList = [];
    fileUrl: string | null = null;
    isDragging = false;
    files: File[] = [];
    // previewUrls: string[] = [];
    selectedIndex: number = 0;
    previewUrls: { url: string; isNew: boolean; file?: File; type?: string }[] =
        [];
    MAX_FILES = 5;
    constructor(
        public dialogRef: MatDialogRef<AddTicketsComponent>,
        private _formBuilder: FormBuilder,
        public snackBar: MatSnackBar,
        private userService: StorageService,
        private cookieService: CookieService,
        private global: Globals,
        private router: Router,
        private httpClient: HttpClient,
        @Inject(MAT_DIALOG_DATA) public data: Tickets,
        public translate: TranslateService,
        public paginationService: AssignService,
        public timeStampService: TimestampService,
        public ticketService: TicketsService,
        private tableRefreshService: TableRefreshService,
        private sanitizer: DomSanitizer
    ) {
        this.minDate = new Date();
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    /**
     * On init
     */
    ngOnInit(): void {
        this.equipmentTypes = JSON.parse(
            localStorage.getItem("equipments")
        ).sort();
        this.ticketForm = this._formBuilder.group({
            title: ["", [Validators.required, Validators.pattern(/^[^\s].*$/)]],
            selectEquipmentType: ["", ""],
            selectSeverityType: [
                "",
                [Validators.required, Validators.pattern(/^[A-Za-z0-9 ]/)],
            ],
            customEquipmentType: ["", [Validators.pattern(/^[^\s].*$/)]],
            assignedTo: [null, [Validators.required]],
            // selectStatus: [
            //     "",
            //     [Validators.required, Validators.pattern(/^[A-Za-z0-9 ]/)],
            // ],
            entitledFor: [
                "",
                [Validators.required, Validators.pattern(/^[A-Za-z0-9 ]/)],
            ],
            description: [
                "",
                [Validators.required, this.wordCountValidator(50)],
            ],
            reasonForIssue: ["", [this.wordCountValidator(50)]],
            // resolutionNotes: ["", ""],
            comments: ["", [this.wordCountValidator(50)]],
            // signature: ["", [Validators.required]],
            upload_file: [""],
        });

        const entitledFor = this.ticketForm.get("entitledFor");
        entitledFor?.valueChanges.subscribe((value) => {
            let equipmentType = this.ticketForm.get("selectEquipmentType");
            if (value === "technician") {
                equipmentType?.setValidators([
                    Validators.required,
                    Validators.pattern(/^[^\s].*$/),
                ]);
                // this.assignedToList = this.technicianList;
            } else {
                equipmentType?.setValue("");
                equipmentType?.clearValidators();
                // this.assignedToList = this.supportList;
            }
            equipmentType?.updateValueAndValidity();
            this.ticketForm.get("assignedTo")?.reset();
        });

        this.name = this.userService.getCookie("name");
        this.labTimeZone = localStorage.getItem("defaultTz");
        this.userId = this.userService.getCookie("userId");

        this.timeStampService.timestamp$.subscribe((ts) => {
            this.uniqueTimestamp = ts;
        });

        setTimeout(() => {
            const inputElement = document.getElementById("title");
            if (inputElement) {
                inputElement.focus();
            }
        }, 0);

        this.ticketForm
            .get("selectEquipmentType")
            ?.valueChanges.subscribe((value) => {
                const customCtrl = this.ticketForm.get("customEquipmentType");

                if (value === "Other") {
                    customCtrl?.setValidators([
                        Validators.required,
                        Validators.pattern(/^[^\s].*$/),
                    ]);
                } else {
                    customCtrl?.clearValidators();
                    customCtrl?.setValue("");
                }

                customCtrl?.updateValueAndValidity();
            });
    }

    goBack() {
        this.router.navigate(["/patient"]).then(() => {
            // this.ngOnDestroy();
            this.ngOnInit();
            // window.location.reload();
        });
    }
    toUpperCaseString(str) {
        return str.trim().toUpperCase();
    }

    openSnackBar(message: string, action: string): void {
        this.snackBar.open(message, action, {
            duration: 10000,
        });
    }

    private handleError(error: Error): void {
        this.hasFirstDataShown = false;
        this.openSnackBar(error.message, this.translateSentence("Common.ok"));
        // this.notify.update(error.message, 'error');
    }

    translateSentence(key: string, params?: any): string {
        return this.translate.instant(key, params);
    }

    toLabMidnightTimestamp(date: Date | string, labTimezone: string): number {
        const dateString = moment(date).format("YYYY-MM-DD");
        return moment.tz(dateString, "YYYY-MM-DD", labTimezone).valueOf();
    }

    addTicket() {
        if (this.hasFirstDataShown) return;
        this.hasFirstDataShown = true;
        let title = this.ticketForm.value.title.trim();
        let description = this.ticketForm.value.description;
        let equipment = this.ticketForm.value.selectEquipmentType.trim();
        let customEquipment = this.ticketForm.value?.customEquipmentType.trim();
        let severity = this.ticketForm.value.selectSeverityType;
        let assignedTo = this.ticketForm.value.assignedTo;
        let reasonForIssue = this.ticketForm.value?.reasonForIssue;
        let commentsBody = this.ticketForm.value.comments;
        let commentedOn = this.uniqueTimestamp
            ? moment(this.uniqueTimestamp).utc().valueOf().toString()
            : moment.utc().valueOf().toString();
        let createdOn = this.uniqueTimestamp
            ? moment(this.uniqueTimestamp).utc().valueOf().toString()
            : moment.utc().valueOf().toString();
        let createdBy = this.name;
        let assigned_on = this.uniqueTimestamp
            ? moment(this.uniqueTimestamp).utc().valueOf().toString()
            : moment.utc().valueOf().toString();
        let assigned_by = this.name;
        let entitledFor = this.ticketForm.value.entitledFor;
        let comments = [
            {
                id: this.generateCommentId(),
                comment_body: commentsBody,
                commented_by: this.name,
                commented_on: commentedOn,
            },
        ];

        // console.log('AssignedTo: ',assignedTo);

        let formData = new FormData();

        formData.append("title", title);
        formData.append(
            "type_of_equipment",
            equipment === "Other" ? customEquipment : equipment
        );

        formData.append("severity", severity.toLowerCase());
        formData.append("assigned_to", JSON.stringify(assignedTo));
        formData.append("status", "open");
        formData.append("description", description);
        formData.append("reason_for_issue", reasonForIssue);
        if (commentsBody) {
            formData.append("comments", JSON.stringify(comments));
        }
        // Append each file individually
        this.files.forEach((file, index) => {
            formData.append("upload_file", file, file.name);
        });
        formData.append("created_on", createdOn);
        formData.append("created_by", createdBy);
        formData.append("assigned_on", assigned_on);
        formData.append("assigned_by", assigned_by);
        formData.append("entitled_for", entitledFor);

        this.ticketService.postTickets(formData).subscribe(
            (response: any) => {
                // console.log("Response from add case:", response);
                if (response && response.status === "success") {
                    this.openSnackBar(
                        this.translateSentence(
                            "Tickets.ticketAddedSuccessfully"
                        ),
                        this.translateSentence("Common.ok")
                    );
                    this.hasFirstDataShown = false;
                    this.ticketForm.reset();
                    this.dialogRef.close();
                    this.tableRefreshService.triggerRefresh();
                } else {
                    this.openSnackBar(
                        this.translateSentence("LabCases.ticketAddFailed"),
                        this.translateSentence("Common.ok")
                    );
                    this.hasFirstDataShown = false;
                }
            },
            (error) => {
                console.log("Inside error block:", error);
                this.hasFirstDataShown = false;
                this.handleError(error);
            }
        );
    }

    generateCommentId(): string {
        const uniqueNumber =
            Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
        return "CMT" + uniqueNumber.toUpperCase();
    }

    fromDateValueChange(event: any) {
        this.startAt = event;
    }
    signaturePadOptions: Object = {
        minWidth: 1,
        canvasWidth: 300,
        canvasHeight: 150,
    };

    drawComplete() {
        const signature = this.signaturePad.toDataURL("image/jpeg", 0.6);
        // console.log("Captured signature:", signature);
        this.ticketForm.get("signature")?.setValue(signature);
    }

    clearSignature() {
        this.signaturePad.clear();
        this.ticketForm.get("signature")?.reset();
    }

    // onDragOver(event: DragEvent) {
    //     event.preventDefault();
    //     this.isDragging = true;
    // }

    // onDragLeave(event: DragEvent) {
    //     event.preventDefault();
    //     this.isDragging = false;
    // }

    // onFileDrop(event: DragEvent) {
    //     event.preventDefault();
    //     this.isDragging = false;
    //     const files = event.dataTransfer?.files;
    //     if (files && files.length > 0) {
    //         this.setFile(files[0]);
    //     }
    // }

    // onFileDropped(event: any) {
    //     const file = event.target.files[0];
    //     if (file) {
    //         this.setFile(file);
    //         const objectUrl = URL.createObjectURL(file);
    //         this.previewUrl =
    //             this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
    //     }
    // }

    // onFileSelect(event: Event) {
    //     const input = event.target as HTMLInputElement;
    //     if (input.files && input.files.length > 0) {
    //         this.setFile(input.files[0]);
    //     }
    // }

    // setFile(file: File) {
    //     if (file.type.startsWith("image/") || file.type.startsWith("video/")) {
    //         this.file = file;
    //         this.fileUrl = URL.createObjectURL(file);
    //     }
    // }

    // removeFile() {
    //     this.file = null;
    //     this.fileUrl = null;
    // }

    // isImage(file: File | null): boolean {
    //     return !!file && file.type.startsWith("image/");
    // }

    // isVideo(file: File | null): boolean {
    //     return !!file && file.type.startsWith("video/");
    // }

    onFileDrop(event: any): void {
        event.preventDefault();
        this.isDragging = false;

        const droppedFiles = event.dataTransfer.files;
        this.handleFiles(droppedFiles);
    }

    onDragOver(event: any): void {
        event.preventDefault();
        this.isDragging = true;
    }

    onDragLeave(event: any): void {
        event.preventDefault();
        this.isDragging = false;
    }

    onFileDropped(event: any): void {
        const selectedFiles = event.target.files;
        this.handleFiles(selectedFiles);
        // console.log(this.files);
    }

    handleFiles(fileList: FileList): void {
        const newFiles = Array.from(fileList);
        if (this.files.length + newFiles.length > this.MAX_FILES) {
            const allowedCount = this.MAX_FILES - this.files.length;
            if (allowedCount <= 0) {
                const msg = this.translateSentence("Tickets.maxFiles", {
                    count: this.MAX_FILES,
                });
                this.openSnackBar(msg, "Ok");
                return;
            }
            newFiles.splice(allowedCount);
            const message = this.translateSentence("Tickets.maxFilesAdded", {
                added: allowedCount,
                max: this.MAX_FILES,
            });
            this.openSnackBar(message, "Ok");
        }

        Array.from(newFiles).forEach((file, index) => {
            const fileIndex = this.files.length;
            this.files.push(file);

            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.previewUrls[fileIndex] = {
                    url: e.target.result,
                    isNew: true,
                    file: file,
                    type: file.type.startsWith("image") ? "image" : "video",
                };
            };
            reader.readAsDataURL(file);
        });
    }

    removeFile(index: number): void {
        this.files.splice(index, 1);
        this.previewUrls.splice(index, 1);
        if (this.previewUrls.length === 0) {
            this.selectedIndex = -1;
        } else if (index >= this.previewUrls.length) {
            this.selectedIndex = this.previewUrls.length - 1;
        } else {
            this.selectedIndex = index;
        }
    }

    isImage(file: File): boolean {
        return file && file.type.startsWith("image/");
    }

    isVideo(file: File): boolean {
        return file && file.type.startsWith("video/");
    }

    selectFile(index: number) {
        this.selectedIndex = index;
    }

    removeAllFiles() {
        this.files = [];
        this.previewUrls = [];
        this.selectedIndex = 0;
    }

    getFileType(url: string): "image" | "video" {
        const ext = url.split(".").pop()?.toLowerCase();

        if (!ext) return "image";

        const imageExts = ["jpg", "jpeg", "png", "gif", "webp"];
        const videoExts = ["mp4", "mov", "avi", "mkv", "webm"];

        if (imageExts.includes(ext)) return "image";
        if (videoExts.includes(ext)) return "video";

        return "image";
    }

    getAssignedTo(role) {
        this.hasFirstDataShown = true;
        this.ticketService.getUsers(role).subscribe(
            (response) => {
                if (response && response.status === "success") {
                    this.hasFirstDataShown = false;
                    let responseData = response.data;

                    this.assignedToList = responseData.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }));

                    // console.log(this.assignedToList);
                } else {
                    this.assignedToList = [];
                    this.openSnackBar(
                        this.translateSentence("Tickets.noTechnicianInLab"),
                        this.translateSentence("Common.ok")
                    );
                    this.hasFirstDataShown = false;
                }
            },
            (error) => {
                console.log("Inside error block:", error);
                this.hasFirstDataShown = false;
                this.handleError(error);
            }
        );
    }

    wordCountValidator(maxWords: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) return null;
            const trimmed = control.value.trim();

            if (trimmed.length === 0) {
                return { whitespaceOnly: true };
            }

            const wordCount = trimmed.trim().split(/\s+/).length;
            return wordCount > maxWords
                ? { wordLimit: { maxWords, actual: wordCount } }
                : null;
        };
    }
}
